<template>
  <div>
    <!-- Start of underWriter review dialog -->
    <v-card>
      <v-toolbar flat>
        <span class="headline">EXPORT</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="hideDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-data-table
          fixed-header
          :headers="headers"
          :items="dataSource"
          :footer-props="footerProps"
          :options.sync="options"
          :server-items-length="options.pageCount"
          :loading="loading"
          class="elevation-1"
          height="450"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.loanNo }}</td>
              <td>{{ assist.tool.formatDate(item.effectiveDate) }}</td>
              <td>{{ assist.tool.getFullName(item) }}</td>
              <td>{{ getProgramTextById(item.program) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          dark
          small
          tile
          @click="exportLoanQueue"
          color="primary"
          class="btn-action p-r-4 m-b-10">
          EXPORT
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- End of underWriter review dialog -->
  </div>
</template>

<script>
import { DataType, Tool, Popup } from '@/util/index'
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'
import { LoanResourceApi, RuntimeApi, LoanOperationApi } from '@/api/pandaria'

const tool = new Tool()
const popup = new Popup()
export default {
  name: 'export-underWriter-dialog',
  components: {
  },
  props: {
    beginDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    },
    loanStatus: {
      type: Number,
      default: 0
    },
    display: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataType: DataType,
      headers: LIST_TABLE_HEADER.ExportUnderWriterHeader,
      dataSource: [],
      loading: false,
      footerProps: {
        'items-per-page-options': [10, 20, 50]
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        pageCount: 0
      },
      assist: {
        tool: tool
      },
      programArray: []
    }
  },
  watch: {
    'store.getters.getAccount': function (val) {
      const portfolioIdList = val.portfolioIdList
      this.listPortfolio(portfolioIdList)
    },
    'options.page': {
      handler () {
        this.searchData()
      }
    },
    'options.itemsPerPage': {
      handler () {
        this.searchData()
      }
    },
    display (val) {
      if (val) {
        this.searchData()
      }
    }
  },
  mounted () {
    this.getProgramArray()
    this.searchData()
  },
  methods: {
    getProgramArray () {
      const $this = this
      RuntimeApi.fetchProgramByPortfolioId(null, function (result) {
        if (tool.isNotEmpty(result)) {
          if (result.length === 1) {
            $this.programArray = result[0]
          } else {
            $this.programArray = result
          }
        } else {
          $this.programArray = []
        }
      }, function () {
        $this.programArray = []
      })
    },
    getProgramTextById (id) {
      let result = ''
      if (tool.isNotEmpty(id)) {
        for (const item of this.programArray) {
          if (parseInt(item.id) === parseInt(id)) {
            result = item.programName
          }
        }
      }
      return result
    },
    searchData () {
      const $this = this
      if (tool.isEmpty($this.loanStatus) || $this.loanStatus === 0) {
        return
      }
      const requestInput = {
        portfolioIds: $this.$store.getters.getRuntimePortfolio,
        loanStatuses: [$this.loanStatus],
        features: 'LOAN_PERSONAL_DATA, LOAN_OPERATION_DATA, LOAN_LOCK_DATA, LOAN_PAYMENT_OPTION_DATA, LOAN_STATUS_DATA',
        page: $this.options.page,
        phase: DataType.LoanPhaseEnum.LOAN_ORIGINATION.value,
        size: $this.options.itemsPerPage,
        beginDate: $this.beginDate,
        endDate: $this.endDate
      }
      $this.loading = true
      this.getQueueCount(requestInput)
      this.getQueueItems(requestInput)
    },
    async getQueueCount (requestInput) {
      const $this = this
      $this.options.pageCount = 0
      const { portfolioIds, loanStatuses, beginDate, endDate } = requestInput
      const input = {
        portfolioIds: portfolioIds,
        loanStatuses: loanStatuses,
        phase: DataType.LoanPhaseEnum.LOAN_ORIGINATION.value,
        beginDate: beginDate,
        endDate: endDate
      }
      await LoanResourceApi.getWorkQueueCount(input, function (data) {
        $this.options.pageCount = tool.isEmpty(data) ? 0 : data
      }, function () {
        $this.options.pageCount = 0
      })
    },
    async getQueueItems (requestInput) {
      const $this = this
      $this.dataSource = []
      await LoanResourceApi.getWorkQueueItem(requestInput, function (data) {
        $this.dataSource = tool.isEmpty(data) ? [] : data
        $this.loading = false
      }, function () {
        $this.dataSource = []
        $this.loading = false
      })
    },
    exportLoanQueue () {
      const $this = this
      popup.popupForQuestion('Are you sure to export data?', {}, function () {
        const requestInput = {
          portfolioIds: $this.$store.getters.getRuntimePortfolio,
          loanStatuses: [$this.loanStatus]
        }
        LoanOperationApi.exportWorkQueueData(requestInput, function (result) {
          if (tool.isNotEmpty(result)) {
            $this.downloadUrl(result)
          } else {
            popup.popupForWarning('Nothing to export')
          }
        }, function (result) {
          popup.popupForError(result.message)
        })
      })
    },
    downloadUrl (url) {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.click()
    },
    hideDialog () {
      this.$emit('hideDialog')
    }
  }
}
</script>

<style>
  .v-textarea textarea {
    resize: none;
  }
</style>
